import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import PDFViewer from "./viewers/PDFViewer"
import VideoViewer from "./viewers/VideoViewer"
import ImageViewer from './viewers/ImageViewer'
import { MEDIA_TYPES } from "../../../config/media"
import { SAVE_VIEWER_CONFIG } from '../store/actionTypes'
import { FlexContainer, TitleH1 } from 'heliocor-ui'

const VIEWER_SIZES = {
    MINI: 'MINI',
    FULL: 'FULL'
}

const MediaViewer = ({
    file,
    height = '',
    mediaType,
    properties = [],
    imgDimensionsForWarning = {},
    viewerSize = VIEWER_SIZES.MINI
}) => {

    const dispatch = useDispatch()
    const viewerConfig = useSelector(state => state.common.viewerConfig || {})
    const handleViewerConfigChange = (config) => dispatch({ type: SAVE_VIEWER_CONFIG, ...config })

    if (mediaType === MEDIA_TYPES.IMAGE) {
        return <ImageViewer
            height={height}
            image={file}
            properties={properties}
            viewerSize={viewerSize}
            imgDimensionsForWarning={imgDimensionsForWarning}
            config={viewerConfig}
            onConfigChange={handleViewerConfigChange}
        />
    } else if (mediaType === MEDIA_TYPES.PDF) {
        return <PDFViewer
            file={file}
            height={height || 732}
            size={viewerSize}
            config={viewerConfig}
            onConfigChange={handleViewerConfigChange}
        />
    } else if (mediaType === MEDIA_TYPES.VIDEO) {
        return <VideoViewer file={file} />
    } else {
        return <FlexContainer padding={5}>
            <Doc>
                <FlexContainer alignItems='center' margin='auto' padding={'95px 20px'}>
                    <VisibilityOffIcon color="disabled" fontSize='large' />
                    <VerticalLine />
                    <TitleH1 style={{ color: '#a4a4a4' }}><srong>No preview available</srong></TitleH1>
                </FlexContainer>
            </Doc>
        </FlexContainer>
    }
}

export { MediaViewer, VIEWER_SIZES }

const Doc = styled.div`
    margin: auto;
    background-color: #ddd;
    width: 200px;
    height: 270px;
`
const VerticalLine = styled.div`
    width: 1px; 
    height: 42px;
    background-color: #a4a4a4;
    margin: 0 10px;
`